import { ViewChild, Component, OnInit, OnChanges, SimpleChanges, DoCheck } from '@angular/core';
import { MultiSourceMultiValueWidget } from "../../base/MultiSourceMultiValueWidget";
import { SharedPoint, SharedSeries } from "src/app/models/dashboard";
import { GaugeComponent } from 'src/app/components/gauge/gauge.component';


@Component({
  selector: "app-gauge-widget",
  templateUrl: "./gauge-widget.component.html",
  styleUrls: ["./gauge-widget.component.css"],
})
export class GaugeWidgetComponent extends MultiSourceMultiValueWidget implements OnChanges, DoCheck {
  @ViewChild('gaugeComp') gaugeComp;

  offset: number;
  public c: any;
  guageConfigObj = {};
  showValue: boolean;

  liveDataOnly(): boolean {
    return (<any>this.widget).period == null || (<any>this.widget).period == "";
  }

  override eventTypes: string[] = ["timeSeriesHover", "timeSeriesUnhover"];
  override timeSeriesEvent(type: string, uri: string, data: any): void {
    // find the series and highlight the one that matches the URI
    // if gaugeType is 'solid' then highlight the whole gauge, else just the needle
    if (this.gaugeComp && this.c.gaugeType == 'solid'){
      const tsdi = this.c.timeSeriesList.find(s => s.uri === uri);
      if (tsdi) {
        if (type === 'timeSeriesHover') {
          //this.gaugeComp.highlightGauge(tsdi);
        } else if (type === 'timeSeriesUnhover') {
          //this.gaugeComp.unhighlightGauge(tsdi);
        }
      }
    }
    else {
      const tsdi = this.c.timeSeriesList.find(s => s.uri === uri);
      if (tsdi) {
        if (type === 'timeSeriesHover') {
          tsdi.highlighted = true;
        } else if (type === 'timeSeriesUnhover') {
          tsdi.highlighted = false;
        }
      }
    }

  }

  override widgetDataLoadComplete(): void {
      
  }

  widgetAfterInit() {}

  widgetBeforeInit() {
    // get the offset from UTC to Local in milliseconds
    this.offset = -(new Date().getTimezoneOffset() * 60 * 1000);
    var series = [];
    this.showValue = false;
    this.c = <any>this.config;
    console.log("LEVEL", this.c);

    const widgetType = this.c.type;
    var currentTime = new Date();
    this.showValue = (this.widget as any).showValue || this.c.size >= 6;

    if (this.c && this.c.timeSeriesList){
      for (const item of this.c.timeSeriesList) {
        item.value = null;
        item.percentage = null;
      }
    }
  }

  refresh() {
    this.ngOnInit();
  }

  widgetDataLoadTimeout(){
    this.gaugeComp.hideLoading();
  }

  widgetLiveDataLoaded(s: any) {
    var item = this.c.timeSeriesList.find(d => d.uri == s.uri);

    item.value = Math.round(s.point.value*1000)/1000;

    this.performSizeCalculations(item);

    //update component UI
    if (this.gaugeComp){
      this.gaugeComp.updateGauge(item.value);
    }
  }

  performSizeCalculations(item){
    //item.value = 2; //temp testing value
    item.percentage = ((item.value - item.min) / (item.max - item.min)) * 100;

    const range = item.max - item.min;
    if (item.min < 0 && item.max > 0){
      item.negativeSize = - item.min / range * 100;
      item.positiveSize = item.max / range * 100;
      if (item.value == 0){
        item.negative = 0;
        item.positive = 0;
      } else if (item.value > 0){
        item.negative = 0;
        item.positive = item.value / item.max * 100;
      } else if (item.value < 0){
        item.positive = 0;
        item.negative = item.value / item.min * 100;
      }
    }
    else if (item.min < 0){
      item.negativeSize = 100;
      item.positiveSize = 0;
      item.negative = ((item.value - item.max) / (item.max - item.min)) * 100;
      item.positive = 0;
    }
    else if (item.max > 0){
      item.negativeSize = 0;
      item.positiveSize = 100;
      item.positive = ((item.value - item.min) / (item.max - item.min)) * 100;
      item.negative = 0;
    }
    //item.positive = 0;
    //item.negative = 50;

    item.percentage = ((item.value - item.min) / (item.max - item.min)) * 100;

    //console.log("Item", item);
    item.colour = null;
    if (item.zoneColours){
      for (let r of item.zoneColours){
        if (item.value >= r.min && item.value <= r.max){
          item.colour = r.colour;
        }
      }
    }
  }

  widgetDataLoaded(s: SharedSeries) {
    // find match
    //var tsdi = this.config.timeSeriesList.find(d => d.uri == s.uri) as any;
    var item = this.c.timeSeriesList[s.index];//.find(d => d.uri == s.uri);
    //var tsdi = this.config.timeSeriesList[0] as any;//s.index] as any;
    //var item = this.c.timeSeriesList[0];//.find(o => o.uri == s.uri);
    if (s.values.length > 0){
      // no more that 3 decimal places allowed
      item.value = Math.round(s.values[s.values.length - 1].value*1000)/1000;
      this.performSizeCalculations(item);
    }
    else {
      item.value = null;
      item.percentage = 0;
      item.positive = null;
      item.negative = null;
    }
    //update component UI
    if (this.gaugeComp){
      this.gaugeComp.updateGauge(item.value);
    }
  }

 /*getColour(ts){
    debugger;
    if (ts.value){
      for (let r of ts.zoneColours){
        if (ts.value >= r.min && ts.value <= r.max){
          return ts.colour;
        }
      }
    }
    return null;
  }*/

  widgetDataAdded(s: SharedPoint) {

  }

  ngDoCheck() {

  }

  ngOnChanges(changes: SimpleChanges) {
  }

}
